var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9941 7.32981H12.3415C12.0502 7.32918 11.7668 7.42397 11.5346 7.59967C11.3023 7.77537 11.134 8.02231 11.0554 8.30272L9.48936 13.8737C9.47927 13.9083 9.45823 13.9387 9.42939 13.9603C9.40055 13.9819 9.36548 13.9936 9.32943 13.9936C9.29339 13.9936 9.25831 13.9819 9.22948 13.9603C9.20064 13.9387 9.17959 13.9083 9.1695 13.8737L5.49109 0.785964C5.481 0.75136 5.45995 0.720962 5.43111 0.699335C5.40228 0.677707 5.3672 0.666016 5.33116 0.666016C5.29511 0.666016 5.26004 0.677707 5.2312 0.699335C5.20236 0.720962 5.18132 0.75136 5.17123 0.785964L3.60524 6.35689C3.52691 6.63621 3.3596 6.88234 3.12868 7.05793C2.89777 7.23352 2.61588 7.32898 2.32579 7.32981H0.666504",
    stroke: "#0A0A0A",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.87f51e864e9b605516ed1c77b2458d10.svg";
export { ForwardRef as ReactComponent };